import React from 'react';

const Search = () => {
    return (
        <svg width={14.081} height={14.081} viewBox="0 0 14.081 14.081">
            <g transform="translate(-1.867 -1.867)">
                <circle
                    cx={5}
                    cy={5}
                    r={5}
                    transform="translate(2.867 2.867)"
                    fill="none"
                    stroke="#8F99DC"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                />
                <path
                    d="M14.533 14.533L11.76 11.76"
                    fill="none"
                    stroke="#8F99DC"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                />
            </g>
        </svg>
    );
};

export default Search;
